// jwt.service.ts
import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { ScriptLoaderService } from './script-loader.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class JwtService {
    private jwtEndpoint = '/generate-tableau-jwt';
    private tokenRefreshInterval = 8 * 60 * 1000; // 8 minutes in milliseconds
    private jwtToken = new BehaviorSubject<string>(null);

    constructor(private http: Http, private scriptLoaderService: ScriptLoaderService) {
    }

    init() {
        this.scriptLoaderService.load('tableau').then(() => {
            console.log('Tableau Script Loaded')
            this.refreshToken();
            setInterval(() => this.refreshToken(), this.tokenRefreshInterval);
        });
    }

    getJWT(): Observable<any> {
        return this.http.get(this.jwtEndpoint)
            .map((response: Response) => {
                const token = response.json().jwt;
                return token;
            })
            .catch((error: any) => {
                let errorMessage = 'Server error';
                try {
                    if (error.json) {
                        const errorJson = error.json();
                        errorMessage = errorJson.error || errorMessage;
                    }
                } catch (e) {
                    console.log('Error getJWT');
                }
                return Observable.throw(errorMessage);
            });
    }

    refreshToken() {
        this.getJWT().subscribe(
            token => {
                this.jwtToken.next(token);
            },
            error => console.error('Error refreshing token:', error)
        );
    }

    isTokenExpired(token: string): boolean {
        if (!token) {
            return true;
        }

        const payload = this.decodeToken(token);
        if (!payload) {
            return true;
        }

        const currentTime = Math.floor(Date.now() / 1000);
        return currentTime > payload.exp;
    }

    private decodeToken(token: string): any {
        try {
            const base64Url = token.split('.')[1];
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));

            return JSON.parse(jsonPayload);
        } catch (e) {
            console.error('Error decoding token:', e);
            return null;
        }
    }

    getToken(): Observable<string> {
        return this.jwtToken.asObservable();
    }
}





// WEBPACK FOOTER //
// ./src/app/common/services/jwt.service.ts